/* eslint-disable */
import React from 'react';
import NumberFormat from 'react-number-format';

const NumberFormatCustom = React.forwardRef(
	function NumberFormatCustom(props: any, ref) {
		const {onChange, decimalScale, prefix, suffix, fixedDecimalScale, ...other} = props;
		const thousandSeparator = other?.thousandSeparator || other?.thousandSeparator === '' ? other.thousandSeparator : true;

		return (
			<NumberFormat
				{...other}
				getInputRef={ref}
				thousandSeparator={thousandSeparator}
				onValueChange={(values) => {
					(onChange) &&
						onChange({
							target: {
								...values,
								value: values.value,
							},
							// fix formik and mui-rff
							currentTarget: {
								...values,
								name: other?.name || 'textNumber',
								value: values.value,
							},
						});
				}}
				decimalSeparator={'.'}
				decimalScale={(decimalScale > 0) ? decimalScale : 0}
				prefix={prefix}
				suffix={suffix}
				fixedDecimalScale={fixedDecimalScale}
			/>
		);
	},
);

export default NumberFormatCustom;
